"use client";

import { useContent } from "@/components/site/ContentProvider";

export function FakeThumbs() {
  const site = useContent();
  const thumbs = [
    { id: "thumbA", extra: "" },
    { id: "thumbC", extra: " _work_ele" },
    { id: "thumbB", extra: "" },
    { id: "thumbD", extra: " _work_ele" },
  ] as const;

  return (
    <>
      {thumbs.map((thumb, i) => {
        const project = site.projects[i];
        return (
          <div
            className={`fk_thumb full_page f a-c j-c${thumb.extra}`}
            id={thumb.id}
            style={{ visibility: "hidden" }}
            aria-hidden="true"
            key={thumb.id}
          >
            <div className="fk_thumb_inner f a-c j-c">
              <div className="fake_work_thumb">
                <div
                  className="fake_work_thumb_scaled work_aspect cover load_bg"
                  data-src={project.cover}
                  role="img"
                  aria-label={project.coverAlt}
                />
                <div className="getSize work_aspect" />
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
}
